import React, { useState, useEffect }from 'react'
import { Button } from '../ButtonElements'
import { InfoContainer, InfoWrapper, InfoRow, Column1, TextWrapper, TopLine, Heading, Subtitle, BtnWrap, Column2, ImgWrap, Img, ImgRound } from './InfoElements'
import { animateScroll as scroll } from 'react-scroll'

import styled from 'styled-components';

const ScrollText = styled.div`
`;

const ScrollText2 = styled.div`

`;


const InfoSection = ({lightBg, id, imgStart, topLine, lightText, darkText, headline, description, buttonLabel, img, alt, primary, dark, dark2, button, link, blank, round}) => {
    const toggleHome = () => {
        scroll.scrollToTop()
    }

    // useEffect(() => {
    //     const handleScroll = () => {
    //     const screenHeight = window.innerHeight;
    //     const newVisibility = Visibility.map(item => {
    //         const itemPosition = document
    //         .getElementById(`fly-${id}${item.id}`)
    //         .getBoundingClientRect().top;
    //         if (itemPosition < screenHeight * 0.8) {
    //         return { ...item, isVisible: true };
    //         }
    //         return item;
    //     });
    //     setVisibility(newVisibility);
    //     };

    //     window.addEventListener('scroll', handleScroll);
    //     return () => {
    //     window.removeEventListener('scroll', handleScroll);
    //     };
    // }, [Visibility]);

  return (
    <>
        <InfoContainer lightBg={lightBg} id={id}>
            <InfoWrapper>
                <InfoRow imgStart={imgStart}>
                    <Column1>
                        <TextWrapper>
                            <ScrollText>
                            <TopLine>{topLine}</TopLine>
                            </ScrollText>
                            <ScrollText>
                            <Heading lightText={lightText}>{headline}</Heading>
                            </ScrollText>
                            <ScrollText>
                            <Subtitle darkText={darkText} dangerouslySetInnerHTML={{ __html: description }}></Subtitle>
                            </ScrollText>
                            <ScrollText>
                            {button === true ?
                            
                            <BtnWrap>
                                <Button to={link}
                                onClick={toggleHome}
                                {...blank ? {target: '_blank'} : null}
                                // smooth={true}
                                // duration={500}
                                // spy={true}
                                exact='true'
                                offset={-80}
                                primary={primary ? 1 : 0}
                                dark={dark ? 1 : 0}
                                dark2={dark2 ? 1 : 0}
                                >
                                    {buttonLabel}
                                </Button>
                            </BtnWrap>
                            
                            : null
                            }    
                            </ScrollText>   
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        <ImgWrap>
                            <ScrollText2>
                              {round === true ? <ImgRound src={img} alt={alt}/> : <Img src={img} alt={alt}/> }
                            </ScrollText2>
                        </ImgWrap>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
        </InfoContainer>
    </>
  )
}

export default InfoSection